import React, { FC, Fragment, ReactNode } from "react";

import { IgRadio, IgTooltip } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

export type IconGridItems = IconGridItem[][];

interface IconGridItem {
  key: string;
  icon: ReactNode;
  checked: boolean;
  isDisabled?: boolean;
}

interface IconGridProps {
  gridKey: string;
  items: IconGridItems;
  onClick: (key: string) => void;
}

export const IconGrid: FC<IconGridProps> = ({ gridKey, items, onClick }) => {
  return (
    <Grid
      container
      item
      direction={"column"}
      justifyContent={"space-around"}
      rowSpacing={1}
    >
      {items.map((row, rowIndex) => {
        return (
          <Fragment key={`icon-grid-${gridKey}-row-${rowIndex}`}>
            <Grid
              container
              item
              direction={"row"}
              justifyContent={"space-around"}
              sx={{ flexWrap: "nowrap" }}
            >
              {row.map((item) => {
                return (
                  <Grid
                    container
                    item
                    direction={"column"}
                    alignItems={"center"}
                    key={`icon-grid-${gridKey}-row-${rowIndex}-item-${item.key}`}
                  >
                    <Grid item>{item.icon}</Grid>
                    <Grid item>
                      <IgTooltip
                        title={
                          item.isDisabled ? "This style is coming soon!" : ""
                        }
                      >
                        <IgRadio
                          disabled={item.isDisabled}
                          checked={item.checked}
                          onClick={() => onClick(item.key)}
                        />
                      </IgTooltip>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
};
